import React from 'react';

// Exibição COMPARTILHADA do veredito dos gates (geração 2d.3 e refino 2d.4): badge geral + segurança
// (schema) + simulação (sim, com achados erro/aviso) + parecer financeiro (advisory, não bloqueia) + o
// desenho da estratégia (condições legíveis + JSON colapsável). Props: cand = { blueprint, ok, gates, _servedBy }.

const RISK_BADGE = { low: 'bg-success', medium: 'bg-warning text-dark', high: 'bg-danger' };
const RISK_LABEL = { low: 'Baixo risco', medium: 'Atenção', high: 'Alto risco' };

function BlueprintGateResults({ cand }) {
    if (!cand || !cand.gates) return null;
    const gates = cand.gates;
    const bp = cand.blueprint;

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between">
                <h6 className="mb-0">Resultado da validação</h6>
                <div>
                    {cand.ok
                        ? <span className="badge bg-success">Aprovada nos gates</span>
                        : <span className="badge bg-danger">Reprovada — não pode salvar</span>}
                    {cand._servedBy && <span className="text-muted small ms-2">via {cand._servedBy}</span>}
                </div>
            </div>

            {/* Gate schema */}
            <div className="mt-2 small">
                <span className={`badge ${gates.schema && gates.schema.valid ? 'bg-success' : 'bg-danger'}`}>
                    Segurança (schema): {gates.schema && gates.schema.valid ? 'OK' : 'falhou'}
                </span>
                {gates.schema && !gates.schema.valid && (
                    <ul className="mb-0 mt-1 ps-3 text-danger">
                        {(gates.schema.errors || []).map((e, i) => <li key={i}>{e}</li>)}
                    </ul>
                )}
            </div>

            {/* Gate sim */}
            {gates.sim && (
                <div className="mt-2 small">
                    <span className={`badge ${gates.sim.ok ? 'bg-success' : 'bg-danger'}`}>
                        Simulação: {gates.sim.ok ? 'OK' : 'falhou'}
                    </span>
                    {(gates.sim.findings || []).length > 0 && (
                        <ul className="mb-0 mt-1 ps-3">
                            {gates.sim.findings.map((f, i) => (
                                <li key={i} className={f.level === 'error' ? 'text-danger' : 'text-warning'}>
                                    <strong>{f.level === 'error' ? '❌' : '⚠️'}</strong> {f.message}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}

            {/* Gate advisory (não bloqueia) */}
            {gates.advisory && !gates.advisory.error && (
                <div className="mt-2 small">
                    <span className={`badge ${RISK_BADGE[gates.advisory.risk] || 'bg-secondary'}`}>
                        Parecer financeiro: {RISK_LABEL[gates.advisory.risk] || gates.advisory.risk}
                    </span>
                    {gates.advisory.summary && <div className="text-muted mt-1">{gates.advisory.summary}</div>}
                    {(gates.advisory.findings || []).length > 0 && (
                        <ul className="mb-0 mt-1 ps-3">
                            {gates.advisory.findings.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                    )}
                </div>
            )}

            {/* Blueprint proposto (leitura) */}
            {bp && (
                <details className="mt-2">
                    <summary className="small text-muted">Ver o desenho da estratégia (avançado)</summary>
                    <div className="small mt-1">
                        {(bp.automations || []).map((a, i) => {
                            const roleKey = typeof a.conditionRole === 'string'
                                ? a.conditionRole
                                : (a.conditionRole && (a.conditionRole.then || a.conditionRole.else));
                            const cond = (bp.conditions || {})[roleKey];
                            return (
                                <div key={i} className="mb-1">
                                    <strong>{a.role}</strong>: <code className="text-break">{cond || '—'}</code>
                                </div>
                            );
                        })}
                        <pre className="bg-light p-2 mt-1 rounded" style={{ maxHeight: '180px', overflow: 'auto' }}>{JSON.stringify(bp, null, 2)}</pre>
                    </div>
                </details>
            )}
        </React.Fragment>
    );
}

export default BlueprintGateResults;
